module.exports = __webpack_public_path__ + "static/media/04 Generali produkcja zwierzęca Ogólne Warunki Ubezpieczenia.7538ae53.pdf";